import { useState, useEffect } from 'react';

const PREF_CATEGORIES = ['ESG', 'Sector', 'Asset Class', 'Geographic', 'Regulatory', 'Personal'];

function makePrefUid() {
  return 'pref_' + Date.now().toString(36) + Math.random().toString(36).substr(2, 4);
}

export default function PreferencesEditor({ preferenceTemplates, stages, onSave, saving }) {
  const [localPrefs, setLocalPrefs] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(PREF_CATEGORIES[0]);

  useEffect(() => {
    setLocalPrefs(preferenceTemplates || []);
  }, [preferenceTemplates]);

  const categoryPrefs = localPrefs
    .filter(p => p.category === selectedCategory)
    .sort((a, b) => a.order - b.order);

  function handleChange(uid, key, value) {
    setLocalPrefs(prev => prev.map(p => p.uid === uid ? { ...p, [key]: value } : p));
  }

  function handleAdd() {
    const existing = localPrefs.filter(p => p.category === selectedCategory);
    const newPref = {
      uid: makePrefUid(),
      pref_name: 'New Preference',
      category: selectedCategory,
      description: '',
      fields: [],
      stage_uid: '',
      order: existing.length + 1,
    };
    setLocalPrefs(prev => [...prev, newPref]);
  }

  function handleDelete(uid) {
    if (!window.confirm('Delete this preference template?')) return;
    setLocalPrefs(prev => prev.filter(p => p.uid !== uid));
  }

  function handleSave() {
    onSave(localPrefs);
  }

  return (
    <div>
      <div className="pm__cat-tabs">
        {PREF_CATEGORIES.map(cat => (
          <button
            key={cat}
            className={`pm__cat-tab ${selectedCategory === cat ? 'pm__cat-tab--active' : ''}`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat} ({localPrefs.filter(p => p.category === cat).length})
          </button>
        ))}
      </div>

      <div className="pm__toolbar">
        <span className="pm__section-title">{selectedCategory} Preferences</span>
        <button className="btn btn--outline-primary" onClick={handleAdd}>+ Add Preference</button>
      </div>

      <div className="pm__pref-list">
        {categoryPrefs.length === 0 && (
          <div className="pm__empty" style={{ marginTop: 'var(--space-lg)' }}>
            No preferences in this category.
          </div>
        )}
        {categoryPrefs.map(pref => (
          <div key={pref.uid} className="pm__pref-row">
            <span style={{ fontSize: '1rem', lineHeight: 1 }}>&#9881;</span>
            <div>
              <input
                className="pm__input pm__input--label"
                style={{ width: '100%', marginBottom: '4px' }}
                value={pref.pref_name}
                onChange={e => handleChange(pref.uid, 'pref_name', e.target.value)}
                placeholder="Preference name"
              />
              <input
                className="pm__input pm__input--hint"
                style={{ width: '100%' }}
                placeholder="Description"
                value={pref.description || ''}
                onChange={e => handleChange(pref.uid, 'description', e.target.value)}
              />
            </div>
            <span className="pm__pref-cat">{pref.category}</span>
            <select
              className="pm__select"
              style={{ width: '100%' }}
              value={pref.stage_uid || ''}
              onChange={e => handleChange(pref.uid, 'stage_uid', e.target.value)}
            >
              <option value="">No stage</option>
              {(stages || []).map(s => (
                <option key={s.uid} value={s.uid}>{s.icon} {s.name}</option>
              ))}
            </select>
            <button className="pm__del-btn" onClick={() => handleDelete(pref.uid)} title="Delete">
              &#10005;
            </button>
          </div>
        ))}
      </div>

      <div className="pm__editor-footer">
        <button
          className={`btn ${saving ? 'btn--disabled' : 'btn--primary'}`}
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
      </div>
    </div>
  );
}
